/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- HELPERS --------------- ++++++++++ */
const fontColor = 'rgb(36, 78, 185)';



/* ++++++++++ --------------- CHARTCARD : STYLES --------------- ++++++++++ */
export default {
    chartcard: {
        height: pxToEm(218),
        minWidth: pxToEm(365),
        padding: pxToEm(20),
        background: '#FFF',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        cursor: 'pointer',
        '& .titleheading': {
            display: 'flex',
            alignItems: 'center',
            width: 'fit-content',
            '& .title': {
                fontSize: pxToEm(16),
                marginRight: pxToEm(10),
                color: fontColor
            },
            '& .changetype': {
                color: themeV2.color.base.gray.dark,
                fontSize: pxToEm(12),
                marginLeft: pxToEm(8)
            },
            maxHeight: pxToEm(24)
        },
        '& .value': {
            fontSize: pxToEm(32),
            fontWeight: '500',
            minWidth: pxToEm(116),
            color: fontColor
        },
        '& .visualization': {
            textAlign: 'center',
            height: pxToEm(100), // make sure parent container have a defined height when using responsive component,
            width: '100%',
            // maxWidth: pxToEm(1000),
            position: 'relative',
            '& text':{
                fill: 'rgb(192, 201, 220) !important'
            },
            '& .tooltip text': {
                fill: '#062b75 !important'
            }
        },
        // ------- loading state ----------//
        '&.isActive': {
            '&-false': {
                '& .titleheading': {
                    '& .title': {
                        color: themeV2.color.base.gray.dark
                    }
                },
                '& .value': {
                    color: themeV2.color.base.gray.dark
                }
            }
        }
    }
};
